import React from 'react';
import { skinOrigin, type Skin } from '../utils/skin';

/** Знак сервиса в шапке входа: сердце socpower на фирменном синем. */
export const SkinMark: React.FC = () => (
  <div className="flex justify-center items-center w-10 h-10 rounded-xl bg-[#3079e0]">
    <svg className="w-5 h-5 text-on-accent" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      />
    </svg>
  </div>
);

/**
 * Документы сервиса под входом: по каким правилам он обрабатывает данные, которые отдаёт VK ID
 * (просьба СОЦПАВЕР.РФ). Страницы — на сайте сервиса.
 */
export const SkinLegal: React.FC<{ skin: Skin; className?: string }> = ({ skin, className = '' }) => {
  const origin = skinOrigin(skin);
  const link = (path: string, text: string) => (
    <a href={`${origin}${path}`} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-zinc-300">
      {text}
    </a>
  );
  return (
    <p className={`text-xs leading-relaxed text-center text-zinc-500 ${className}`}>
      Продолжая, вы принимаете{' '}
      {link('/docs/terms/', 'пользовательское соглашение')}, {link('/docs/privacy/', 'политику обработки персональных данных')} и даёте{' '}
      {link('/docs/consent/', 'согласие на их обработку')}.
    </p>
  );
};
